import React from 'react';
import './Feedback.css';
import { trackFeedback } from '../utils/analytics';

const Feedback: React.FC = () => {
  return (
    <div className="feedback-page">
      <div className="feedback-header">
        <div className="container">
          <div className="feedback-logo-word">LITSCAN</div>
          <h1>Get In Touch</h1>
          <p className="feedback-subtitle">
            Have a feature idea, found a bug, or want to partner with us? We want to hear from you.
          </p>
        </div>
      </div>

      <div className="feedback-content">
        <div className="container">
          <div className="feedback-options">
            <div className="feedback-option">
              <div className="feedback-icon">📧</div>
              <h2>Email Us</h2>
              <p>Questions, support, or just want to say what's up? Drop us a line and we'll respond fast.</p>
              <a
                href="mailto:support@litscan.app"
                className="btn btn-primary btn-large"
                onClick={() => {
                  trackFeedback('email');
                }}
              >
                Email support@litscan.app
              </a>
            </div>

            <div className="feedback-option">
              <div className="feedback-icon">🏢</div>
              <h2>Venue & Brand Partnerships</h2>
              <p>Want your venue featured on LITSCAN? Interested in a city takeover or sponsorship deal? Let's talk.</p>
              <a
                href="mailto:support@litscan.app?subject=Venue/Brand Partnership Interest"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-secondary btn-large"
                onClick={() => {
                  trackFeedback('portal');
                }}
              >
                Partner With Us
              </a>
            </div>
          </div>

          <div className="feedback-info">
            <h3>What We Want to Hear</h3>
            <div className="feedback-info-grid">
              <div className="info-item">
                <span className="info-emoji">🐛</span>
                <h4>Bug Reports</h4>
                <p>Something not working? Tell us.</p>
              </div>
              <div className="info-item">
                <span className="info-emoji">✨</span>
                <h4>Feature Ideas</h4>
                <p>Want a new city, new feature, new vibe level? Say it.</p>
              </div>
              <div className="info-item">
                <span className="info-emoji">🏢</span>
                <h4>Venue Inquiries</h4>
                <p>Get your bar or club in front of the right crowd tonight.</p>
              </div>
              <div className="info-item">
                <span className="info-emoji">🔥</span>
                <h4>Beta Feedback</h4>
                <p>In the beta? Tell us what hit and what missed.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="feedback-footer">
        <div className="container">
          <p>Built for the night. Powered by you. 🔥</p>
          <a href="/" className="back-home">← Back to Home</a>
        </div>
      </div>
    </div>
  );
};

export default Feedback;

